import { createContentModelSelector } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
export const getMaximumRateLimitOption = createContentModelSelector('maximumRateLimitOption');
export const getMaximumRateLimitPerMinute = createContentModelSelector('maximumRateLimitPerMinute');